// extracted by mini-css-extract-plugin
module.exports = {"login_box":"Login_login_box__2DVOT","login_form":"Login_login_form__3DIHg"};